import {useLocation, Outlet } from "react-router";
import { useLayoutEffect } from "react";
import ButtonAppBar from "./UI/Appbar";
//import Footer from "./UI/Footer/Footer";
import { Container } from "react-bootstrap";
import Footer from "./UI/Appbar/Footer";


function App() {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="app">
      <ButtonAppBar />
      <Container className="App p-0" fluid>
        <Outlet />
      </Container>
      <Footer/>
    </div>
  );
}

export default App;
